module.exports = __webpack_public_path__ + "static/media/icon_menu.6b78bb42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_menu.svg
// module id = 772
// module chunks = 0